import './index.scss'
function ClearDiv(props){
  console.log(props)
    return (
        <div className={`clear-div ${props.className}`}>{props.children}</div>
    )
}
export default ClearDiv;